<template>
    <div class="external-activity--card" :style="`border-radius: ${activity.card_border_radius}px`">
        <div class="external-activity--card-content external-activity--card-flex">
            <div class="info-container">
                <h4 class="text-center">{{ defaultCartLanguage.room_service_prompt }}</h4>
                <p class="text-center" style="line-height: 24px">
                    {{ defaultCartLanguage.pin_prompt }}
                </p>
                <div class="input-wrapper">
                  <PincodeInput
                    v-model="code"
                    placeholder=""
                  />
                </div>
                <span v-if="loginError"><small style="color: red" class="text-center">{{ loginError }}</small></span>
                <button class="btn btn-block" :style="canSubmitCode ? '': 'background-color: #EDEDED!important; color: #908c8c!important'" @click.prevent="attemptLogin" :disabled="!canSubmitCode">{{ defaultCartLanguage.pin_button }}</button>
            </div>
        </div>
    </div>
</template>
<script>
    import PincodeInput from 'vue-pincode-input';
    import EventBus from '../../EventBus'
    import { mapGetters, mapActions } from 'vuex'
    export default {
        props: ['activity', 'user'],
        components: {
            PincodeInput
        },

        computed: {
            ...mapGetters(['defaultCartLanguage']),
            canSubmitCode() {
                return this.code.length == 4
            },
        },

        data () {
            return {
                localUser: this.user,
                loginError: null,
                code: '',
            }
        },

        methods: {
            ...mapActions(['emptyCart']),

            attemptLogin () {
                this.loginError = null;

                window.axios.post(`/${this.activity.uuid}/login`, {code: this.code}).then((response) => {
                    this.localUser = response.data.user
                    this.emptyCart()
                    EventBus.$emit('login', {
                        user: this.localUser
                    })
                }).catch((err) => {
                    console.log(err.response.data.result)
                    this.loginError = "Accesso non valido"
                })
            },
        }
    }
</script>
<style>
    .vue-pincode-input {
        box-shadow: none!important;
    }

    .vue-pincode-input:focus {
            background-color: white!important;
            border: 2px solid #01AD83!important;
    }

    input.vue-pincode-input {
        background-color: #EDEDED!important;
        border: none;
    }
</style>
